<i18n>
{
  "no": {
    "PW_RULES": {
      "TITLE": "Passordregler",
      "1" : "Minst 8 tegn",
      "2" : "Ikke en dato",
      "3" : "Ikke for mange tegn som følger hverandre i alfabetet",
      "4" : "Ikke for mange tegn som er ved siden hverandre på tastaturet",
      "5" : "Ikke et passord som er mye brukt og kjent fra passordlekasjer"
    }
  },
  "en": {
    "PW_RULES": {
      "TITLE": "Password rules",
      "1" : "At least 8 characters",
      "2" : "Not a date",
      "3" : "Not too many alphabetical neighbours in a row",
      "4" : "Not too many keyboard neighbours in a row",
      "5" : "Not a common password found in data breaches"
    }
  }
}
</i18n>

<template>
  <details class="password-rules">
    <summary class="password-rules-summary">{{ t('PW_RULES.TITLE') }}</summary>
    <ul class="password-rules-list">
      <li v-for="rule in rules" :key="rule">{{ rule }}</li>
    </ul>
  </details>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const rules = computed(() => [1, 2, 3, 4, 5].map((i) => t(`PW_RULES.${i}`)));
</script>

<style scoped>
.password-rules {
  padding-block: 8px;
}

.password-rules-summary {
  cursor: pointer;
}

.password-rules-list {
  padding-left: 36px;
  list-style: disc;
}
</style>
